// EVENTS.COMPONENTS.APPLICATION.REWARDS.REDEEM.REDEMPTION_MODAL

export const REDEMPTION_MODAL = {
  VIEWED_MODAL: 'redemption-viewed_modal',
  CLOSED_MODAL: 'redemption-closed_modal',
  REDEEMED_ITEM: 'redemptionnModal-redeemed_item'
};
